module.exports = __webpack_public_path__ + "img/products.28a03744.svg";